import { IEducationalScenarioItem } from "../../educational-scenario-items";
import { IApiMutationFunction, createApiMutationHook } from "../../utils/api";
import { RelationalValue } from "../../utils/filters";
import { mapRelationalValue } from "./../../utils/filters";

export type IEducationalScenarioItemUpdateMutationParameters = {
    educationalScenarioItem: RelationalValue<IEducationalScenarioItem>;
    startDate: string;
    endDate: string;
};

export type IEducationalScenarioItemUpdateMutationResult = IEducationalScenarioItem;

export const educationalScenarioItemUpdateMutation: IApiMutationFunction<
    IEducationalScenarioItemUpdateMutationParameters
> = ({ educationalScenarioItem, startDate, endDate }) => {
    return {
        method: "PUT",
        url: `/educational_scenario_items/${mapRelationalValue(educationalScenarioItem)}`,
        data: {
            startDate,
            endDate,
        },
    };
};

export const useEducationalScenarioItemUpdateMutation = createApiMutationHook<
    IEducationalScenarioItemUpdateMutationParameters,
    IEducationalScenarioItemUpdateMutationResult
>(educationalScenarioItemUpdateMutation);
